/* eslint semi:0 */
import BaseView from './BaseView'

export default class ModalView extends BaseView {
  view(ctrl) {}
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/EmptyView.js